"use strict";
import { MINT_CONFIG } from "pages/Mint/MintConfig";
import { currencyId } from "uniswap/src/utils/currencyId";
export const MINT_MODES = ["mint"];
function normalizedCurrencyId(currency) {
  return currency ? currencyId(currency).toLowerCase() : void 0;
}
function getMintAllowedCurrencies(config = MINT_CONFIG) {
  return config.usdr ? [config.usdr, ...config.stables] : config.stables;
}
export function getMintAllowedCurrencySymbols(config = MINT_CONFIG) {
  return getMintAllowedCurrencies(config).map((currency) => currency.symbol ?? "");
}
export function isMintStableCurrency(currency, config = MINT_CONFIG) {
  const id = normalizedCurrencyId(currency);
  return Boolean(id && config.stables.some((stable) => normalizedCurrencyId(stable) === id));
}
export function isMintOutputCurrency(currency, config = MINT_CONFIG) {
  return Boolean(config.usdr && normalizedCurrencyId(currency) === normalizedCurrencyId(config.usdr));
}
export function isMintAllowedCurrency(currency, config = MINT_CONFIG) {
  return isMintStableCurrency(currency, config) || isMintOutputCurrency(currency, config);
}
function getDefaultMintStable(config = MINT_CONFIG) {
  return config.stables[0];
}
export function normalizeMintPair(input, output, config = MINT_CONFIG) {
  const normalizedInput = isMintStableCurrency(input, config) ? input : getDefaultMintStable(config);
  const normalizedOutput = isMintOutputCurrency(output, config) ? output : config.usdr;
  return {
    input: normalizedInput,
    output: normalizedOutput,
    wasCorrected: normalizedInput !== input || normalizedOutput !== output
  };
}
